export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/components/security/_Login.vue")
    }
];
